import { toGraphqlDto, zodOptional } from '@studio/utils/zod';
import { z } from 'zod';

export const ZWidgetLibraryAsset = z.object({
    id: z.string(),
    thumbnail: zodOptional(z.string()),
    bannerflowLibraryId: zodOptional(z.string()),
    created: z.string(),
    modified: zodOptional(z.string())
});

export type IWidgetLibraryAsset = z.infer<typeof ZWidgetLibraryAsset>;

export enum LibraryWidgetState {
    Active = 0,
    Inactive = 1
}

export const ZLibraryWidget = z.object({
    id: zodOptional(z.string()),
    name: z.string(),
    thumbnailUrl: zodOptional(z.string()),
    comment: z.string(),
    properties: z.array(
        z.object({
            name: z.string(),
            label: zodOptional(z.string()),
            value: zodOptional(z.string()),
            unit: zodOptional(z.string())
        })
    ),
    exportable: z.boolean(),
    state: zodOptional(z.nativeEnum(LibraryWidgetState)),
    versionId: zodOptional(z.string()),
    imported: zodOptional(z.boolean()),
    created: z.optional(z.string()),
    modified: z.optional(z.string())
});
export type LibraryWidget = z.infer<typeof ZLibraryWidget>;

/**
 * Query types
 */

export type CreateWidgetAssetResult = { createWidgetAsset: CreateWidgetAssetDto };
export interface CreateWidgetVariables {
    widget: {
        thumbnail?: string;
    };
    brandId: string;
}
export const ZWidgetLibraryAssetDto = ZWidgetLibraryAsset.extend({});
export const WIDGET_LIBRARY_ASSET_DEFINTION = `{ ${toGraphqlDto(ZWidgetLibraryAssetDto)} }`;
export interface CreateWidgetAssetDto extends z.infer<typeof ZWidgetLibraryAssetDto> {}

export type UpdateWidgetAssetResult = { updateWidgetAsset: IWidgetLibraryAsset };
export interface IUpdateWidgetVariables {
    id: string;
    widget: Omit<IWidgetLibraryAsset, 'created' | 'modified'>;
    brandId: string;
    accountSlug: string;
}
